import { Action } from 'redux';
import { HierarchyEntity, HierarchyType } from 'services/resources';
import { FailureActionTypes } from 'services/utilityTypes';

const HIERARCHY_ACTION_BASE = 'app/services/Hierarchy/';

export enum ActionTypes {
  START_HIERARCHY_LOADING = HIERARCHY_ACTION_BASE + 'START_HIERARCHY_LOADING',
  GET_HIERARCHY_SUCCESS = HIERARCHY_ACTION_BASE + 'GET_HIERARCHY_SUCCESS',
  GET_HIERARCHY_FAIL = HIERARCHY_ACTION_BASE + 'GET_HIERARCHY_FAIL',
  SET_SELECTED_ENTITY = HIERARCHY_ACTION_BASE + 'SET_SELECTED_ENTITY',
}

export type SelectedEntityType = HierarchyType | number;

type HierarchyFailureActionTypes = FailureActionTypes<ActionTypes>;

interface ActionBase extends Action {
  type: ActionTypes;
  payload?: Record<string, unknown>;
}

interface StartHierarchyLoadingAction extends ActionBase {
  type: ActionTypes.START_HIERARCHY_LOADING;
}

interface GetHierarchyAction extends ActionBase {
  type: ActionTypes.GET_HIERARCHY_SUCCESS;
  payload: {
    hierarchy: HierarchyEntity[];
  };
}

interface SetSelectedEntityAction extends ActionBase {
  type: ActionTypes.SET_SELECTED_ENTITY;
  payload: {
    scope: SelectedEntityType;
  };
}

interface FailureAction extends ActionBase {
  type: HierarchyFailureActionTypes;
  payload: {
    error: string;
  };
}

export type HierarchyAction =
  | StartHierarchyLoadingAction
  | GetHierarchyAction
  | SetSelectedEntityAction
  | FailureAction;

export const startHierarchyLoading = (): StartHierarchyLoadingAction => ({
  type: ActionTypes.START_HIERARCHY_LOADING,
});

export const receivedGetHierarchySuccess = (hierarchy: HierarchyEntity[]): HierarchyAction => ({
  type: ActionTypes.GET_HIERARCHY_SUCCESS,
  payload: {
    hierarchy,
  },
});

export const receivedGetHierarchyFail = (error: string): HierarchyAction => ({
  type: ActionTypes.GET_HIERARCHY_FAIL,
  payload: {
    error,
  },
});

export const setSelectedEntity = (scope: SelectedEntityType): ActionBase => ({
  type: ActionTypes.SET_SELECTED_ENTITY,
  payload: {
    scope,
  },
});
